import { createPinia } from 'pinia';
import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/vue3';

// Plugins
import i18n from './plugins/vue-i18n';
import vuetify from './plugins/vuetify.ts';
import './plugins/leaflet';

// STYLES
// Main Theme SCSS
import '../sass/theme.scss';

// App SCSS
import '../sass/app.scss';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';

/*
|---------------------------------------------------------------------
| Main Vue Instance
|---------------------------------------------------------------------
|
| Render the vue application on the <div id="app"></div> in index.html
*/
createInertiaApp({
  title: (title) => `${title} - Order service`,
  resolve: (name) =>
    // @ts-ignore
    resolvePageComponent(`./pages/${name}.vue`, import.meta.glob('./pages/**/*.vue')),
  setup({ el, App, props, plugin }) {
    createApp({ render: () => h(App, props) })
      .use(plugin)
      .use(i18n)
      .use(createPinia())
      .use(vuetify)
      .mount(el);
  },
}).then();
